module.exports = __webpack_public_path__ + "static/media/aboutimage.9ed988ff.jpg";